<template>
  <div class="account_info_box">
    <div class="info_item">
      <p class="item_title">{{ $t('center.User_information') }}</p>
      <div class="user_info_box">
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('center.user_name') }}</div>
          <div class="user_info_desc">{{ accountInfo.loginName }}</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('register.name') }}</div>
          <div class="user_info_desc">{{ accountInfo.name }}</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('login.phone_number') }}</div>
          <div class="user_info_desc">{{ accountInfo.mobile }}</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('booking.email') }}</div>
          <div class="user_info_desc">{{ accountInfo.email }}</div>
        </div>
      </div>
    </div>
    <div class="info_item">
      <p class="item_title">{{ $t('center.Enterprise_information') }}</p>
      <div class="user_info_box">
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('center.Enterprise_No') }}</div>
          <div class="user_info_desc">{{ accountInfo.partnerCode }}</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('center.Enterprise_name') }}</div>
          <div class="user_info_desc">{{ accountInfo.companyName }}</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('center.status') }}</div>
          <div class="user_info_desc"
            style="display: grid;grid-template-columns: repeat(2, max-content);align-items: center;grid-column-gap: 6px;">
            <img src="../../../assets/newImage/icon.png" alt="">
            <span v-if="accountInfo.status == 1">{{ $t('center.normal') }}</span>
            <span v-else style="color: red;">{{ $t('center.abnormal') }}</span>
          </div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('center.City') }}</div>
          <div class="user_info_desc">{{ accountInfo.region }}</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">
            <span>总授信额度</span>
            <el-tooltip class="item" effect="dark" content="总授信额度=初始授信额度+临时增加额度，临时额度到期时，总授信额度将同步更新" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div class="user_info_desc">
            {{ getAllAmount() }}
          </div>
        </div>
        <div class="user_info_item" v-if="temporaryCreditList && temporaryCreditList.length > 0">
          <div class="user_info_title">
            <span>临时额度</span>
            <el-tooltip class="item" effect="dark" content="临时增加的额度，并设有有效期。在有效期截止时，将一次性从可用额度中扣除" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div class="user_info_desc">
            <div v-for="(item, index) in temporaryCreditList" :key="index" style="display: flex;">
              <div style="min-width: 45px;">
                {{ item.amount / 100 }}
              </div>
              <div>
                <span style="margin: 0 5px;">到期时间:</span>
                {{ item.expireTime }}
              </div>
            </div>
          </div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">
            剩余可用额度
            <el-tooltip class="item" effect="dark" content="实时可用额度=总授信额度+充值额度-已占用的额度，根据订单预订、取消或充值后实时更新" placement="top">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <div class="user_info_desc" style="color: #1e50f0;">
            <span v-if="accountInfo.creditAmount">CNY {{ accountInfo.creditAmount / 100 }}</span>
            <span v-else>CNY 0</span>
          </div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">{{ $t('center.Settlement_method') }}</div>
          <div class="user_info_desc">
            <span v-if="accountInfo.settleWay == 1">{{ $t('center.Single_settlement') }}</span>
            <span v-if="accountInfo.settleWay == 0">{{ $t('center.Monthly_settlement') }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="info_item" v-if="accountInfo.settleWay == 0">
      <p class="item_title">{{ $t('center.Recharge_information') }}</p>
      <div class="user_info_box">
        <div class="user_info_item">
          <div class="user_info_title">收款账号</div>
          <div class="user_info_desc">755966071410308</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">账户名称</div>
          <div class="user_info_desc">深圳市科坦国际旅行社有限公司</div>
        </div>
        <div class="user_info_item">
          <div class="user_info_title">开户行</div>
          <div class="user_info_desc">招商银行深圳福永支行</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      navigates: [
        { id: 1, name: '账户管理', url: '/account' }
      ],
      loginInfo: {},
      accountInfo: {},
      updateForm: {
        oldPsw: '',
        newPsw: '',
        rePsw: ''
      },
      customColors: [
        { color: '#f56c6c', percentage: 34 },
        { color: '#e6a23c', percentage: 67 },
        { color: '#5cb87a', percentage: 100 }
      ],
      pswSafePercent: 0,
      pswIsNotSame: false,
      contactList: [],
      editContactForm: {},
      isShowEditContact: false,
      isSelectGeneral: false,
      isSelectSpecial: false,
      temporaryCreditList: [],
      currCreditAmount: 0
    }
  },
  components: {
  },
  mounted () {
    this.$commonUtil.modfiyicon()
  },
  activated () {
    this.init()
  },
  methods: {
    init () {
      this.loginInfo = this.$commonUtil.getPartnerInfo()
      let req = {
        partnerCode: this.loginInfo.partnerCode,
        loginName: this.loginInfo.loginName
      }
      let vm = this
      vm.$http.get('/b2b/getPartnerInfo', { params: req }).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.accountInfo = result.data
        } else {
          vm.$message.error('错误：' + result.message)
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
      })
      let reqChannel = {
        channelId: this.loginInfo.homeChannelId
      }

      vm.$http.get('/b2b/getChannel', { params: reqChannel }).then(resp => {
        const result = resp.body
        if (result != undefined) {
          const obj = JSON.parse(result.invoiceConfig)
          vm.isSelectGeneral = obj['isSelectGeneral'] == 1
          vm.isSelectSpecial = obj['isSelectSpecial'] == 1
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      })
      vm.getContactInfo()
      vm.getTemporaryCredit()
      vm.getCreditAmountByType()
    },
    updatePsw () {
      let patrnTrue = /^(\w|@|#|\*|-){6,20}$/
      if (!patrnTrue.exec(this.updateForm.newPsw)) {
        this.$message.warning('请填写符合规则密码')
        return
      }
      if (this.updateForm.newPsw != this.updateForm.rePsw) {
        return
      }
      let req = {
        loginName: this.loginInfo.loginName,
        oldPsw: this.updateForm.oldPsw,
        newPsw: this.updateForm.newPsw
      }
      let vm = this
      vm.$http.get('/b2b/updatePsw', { params: req }).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.$message.success('修改成功')
          vm.updateForm = {
            oldPsw: '',
            newPsw: '',
            rePsw: ''
          }
        } else {
          vm.$message.error(result.message)
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
      })
    },
    changeRePsw () {
      if (this.updateForm.newPsw == '' || this.updateForm.rePsw == '') {
        this.pswIsNotSame = false
      } else if (this.updateForm.newPsw != this.updateForm.rePsw) {
        this.pswIsNotSame = true
      } else {
        this.pswIsNotSame = false
      }
    },
    calPswComplex () {
      let patrnTrue = /^(\w|@|#|\*|-){6,20}$/
      let patrnNum = /[0-9]/
      let patrnGrap = /[a-zA-Z]/
      let patrnSpec = /[@#*_-]/
      if (patrnTrue.exec(this.updateForm.newPsw)) {
        if (patrnNum.exec(this.updateForm.newPsw)
          && patrnGrap.exec(this.updateForm.newPsw)
          && patrnSpec.exec(this.updateForm.newPsw)) {
          this.pswSafePercent = 100
        } else if (patrnNum.exec(this.updateForm.newPsw)
          && patrnGrap.exec(this.updateForm.newPsw)) {
          this.pswSafePercent = 66
        } else {
          this.pswSafePercent = 33
        }
      } else {
        this.pswSafePercent = 0
      }
    },
    showEditContact (type, row) {
      // type 0 新增，1编辑
      if (type == 0) {
        this.editContactForm = {
          title: '新增预订联系人',
          partnerCode: this.loginInfo.partnerCode
        }
      } else {
        this.editContactForm = {
          title: '编辑预订联系人',
          id: row.id,
          partnerCode: this.loginInfo.partnerCode,
          contactName: row.contactName,
          contactPhone: row.contactPhone,
          contactEmail: row.contactEmail
        }
      }
      this.isShowEditContact = true
    },
    getContactInfo () {
      let headers = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      let vm = this
      vm.$http.get(`/b2b/getB2BContactInfo?partnerCode=${this.loginInfo.partnerCode}`, { headers }).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.contactList = result.data
        } else {
          vm.$message.error('错误：' + result.message)
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
      })
    },
    async getTemporaryCredit () {
      let req = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      const { data: result } = await this.$http.get('/mini/tranTempLogs', { headers: req })
      if (result.code == 200) {
        this.temporaryCreditList = result.data
      }
    },
    async getCreditAmountByType() {
      let req = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      const { data: result } = await this.$http.get(`/mini/getCreditAmountByType?subTransactionType=1`, { headers: req })
      if (result.code === 200) {
        this.currCreditAmount = result.data
      }
    },
    getAllAmount() {
      let currCreditAmount = this.currCreditAmount ? this.currCreditAmount : 0
      let temporaryAmount = this.temporaryCreditList.reduce((acc, curr) => {
        return acc + curr.amount
      }, 0)
      return (currCreditAmount + temporaryAmount) / 100
    },
    saveEditContact () {
      let vm = this
      vm.$http.post('/b2b/saveB2BContactInfo', vm.editContactForm).then(resp => {
        let result = resp.body
        if (result.success) {
          vm.$message.success('保存成功')
        } else {
          vm.$message.error(result.message)
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
        vm.isShowEditContact = false
        vm.getContactInfo()
      })
    },
    delContact (id) {
      let vm = this
      vm.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.$http.get('/b2b/delB2BContactInfo', { params: { delId: id } }).then(resp => {
          let result = resp.body
          if (result.success) {
            vm.$message.success('删除成功')
          } else {
            vm.$message.error('错误：' + result.message)
          }
        }).catch(resp => {
          vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
        }).finally(() => {
          vm.getContactInfo()
        })
      }).catch(() => {
      })
    }
  },
  watch: {
    'updateForm.newPsw' () {
      this.changeRePsw()
      this.calPswComplex()
    },
    'updateForm.rePsw' () {
      this.changeRePsw()
    }
  }
}
</script>

<style lang="less" scoped>
.account_info_box {
  .info_item {
    width: 100%;
    min-height: 150px;
    background-color: #fff;
    margin-bottom: 20px;
    padding: 20px;

    .item_title {
      font-size: 16px;
      font-weight: bold;
      font-family: '苹方';
      margin-bottom: 12px;
    }

    .user_info_box {
      width: 50%;
      font-size: 13px;
      color: #676767;

      .user_info_item {
        display: grid;
        grid-template-columns: 150px 1fr;
        border: 1px solid #e7e7e7;
        border-collapse: collapse;
        margin-top: -1px;

        .user_info_title {
          width: 150px;
          justify-content: center;
          display: flex;
          align-items: center;
          column-gap: 5px;
          min-height: 40px;
          background-color: #f7f7f7;
          padding-right: 10px;
        }

        .user_info_desc {
          min-height: 40px;
          line-height: 40px;
          padding-left: 10px;
        }
      }
    }

    .recharge_box {
      width: 50%;
      color: #676767;

      .pay_methods {

        border: 1px solid #e7e7e7;
        border-collapse: collapse;

        .pay_methods_text {
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #e7e7e7;
          padding-left: 20px;
          font-size: 13px;
        }

        .pay_methods_desc {
          display: grid;
          grid-template-columns: 160px auto;

          .pay_methods_title {
            height: 40px;
            line-height: 40px;
            background-color: #f7f7f7;
            text-align: right;
            padding-right: 10px;
            border-bottom: 1px solid #e7e7e7;
          }

          .pay_methods_desc_com {
            height: 40px;
            line-height: 40px;
            padding-left: 10px;
            border-bottom: 1px solid #e7e7e7;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/order/AccountInfo.vue